export default __webpack_public_path__ + "static/media/GarageSkill.78bb5074.PNG";